/**
 * @generated SignedSource<<3eedf0c11a3671e85f20af0d7765dc61>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type topicDescriptionTopic$data = {
  readonly chineseName: string | null | undefined;
  readonly description: {
    readonly text: string | null | undefined;
  } | null | undefined;
  readonly extraMetadata: ReadonlyArray<{
    readonly __typename: "ExtraMetadata";
  } | null | undefined> | null | undefined;
  readonly mobileImage: {
    readonly style: {
      readonly url: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly name: string;
  readonly sponsor: {
    readonly __typename: "Sponsor";
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"entityFollowButtonBase" | "entityLink" | "hooksTopic" | "topicHeaderRelatedLinksTopic" | "topicMetadataDisplayTopic">;
  readonly " $fragmentType": "topicDescriptionTopic";
};
export type topicDescriptionTopic$key = {
  readonly " $data"?: topicDescriptionTopic$data;
  readonly " $fragmentSpreads": FragmentRefs<"topicDescriptionTopic">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }
],
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "Sponsor",
  "kind": "LinkedField",
  "name": "sponsor",
  "plural": false,
  "selections": (v0/*: any*/),
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "topicDescriptionTopic",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "topicHeaderRelatedLinksTopic"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityFollowButtonBase"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "hooksTopic",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "types",
          "storageKey": null
        },
        (v1/*: any*/)
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "topicMetadataDisplayTopic"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ExtraMetadata",
      "kind": "LinkedField",
      "name": "extraMetadata",
      "plural": true,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityLink"
    },
    {
      "alias": "mobileImage",
      "args": [
        {
          "kind": "Literal",
          "name": "type",
          "value": "MOBILE_APP_IMAGE"
        }
      ],
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "image",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "style": "300x300"
              }
            }
          ],
          "concreteType": "ImageStyle",
          "kind": "LinkedField",
          "name": "style",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            }
          ],
          "storageKey": "style(filter:{\"style\":\"300x300\"})"
        }
      ],
      "storageKey": "image(type:\"MOBILE_APP_IMAGE\")"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "description",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "chineseName",
      "storageKey": null
    },
    (v1/*: any*/)
  ],
  "type": "Topic",
  "abstractKey": null
};
})();

(node as any).hash = "066f30427b0e470beedfe2e898cdefc0";

export default node;
